import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Tab-bearing routes end in a splat (`entities/:id/*`): the first segment
// after `basePath` names the tab, and any deeper segments belong to that
// tab's own sub-route. `defaultTab` applies when the URL names no tab.
export function useAppTabs({ basePath = "", defaultTab = "" }) {
  const params = useParams();
  const navigate = useNavigate();

  const activeTab = params["*"]?.split("/")[0] || defaultTab;

  const handleTabChange = useCallback(
    (_e, { name }) => {
      navigate(`${basePath}/${name}`);
    },
    [navigate, basePath]
  );

  return {
    activeTab,
    defaultTab,
    basePath,
    handleTabChange,
  };
}
